<template>
    <div class="flex w-full text-lg">
        <div class="text-left">
            <div>
                {{ $t('inventory.new') }}
            </div>
            <div>
                {{ $t('inventory.used') }}
            </div>
            <div v-if="cards.totalVehicles.unknown.count">
                {{ $t('inventory.statistics.unknown') }}
            </div>
            <div>
                {{ $t('inventory.statistics.totalVehicles') }}
            </div>
        </div>
        <div class="text-right ml-3">
            <div>
                <span class="font-bold">{{ cards.totalVehicles.new.count }} </span>
                <span class="text-grey-6500"
                    >({{ cards.totalVehicles.demo.count }} {{ $t('inventory.demo') }})</span
                >
            </div>
            <div>
                <span class="font-bold">{{ cards.totalVehicles.used.count }} </span>
                <span class="text-grey-6500"
                    >({{ cards.totalVehicles.certified.count }}
                    {{ $t('inventory.vehicle.certified') }})</span
                >
            </div>
            <div>
                <span class="font-bold" v-if="cards.totalVehicles.unknown.count">{{
                    cards.totalVehicles.unknown.count
                }}</span>
            </div>
            <div>
                <span class="font-bold">{{ cards.totalVehicles.number.count }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cards: {
                type: Object,
                default: () => {},
            },
        },
    };
</script>
